import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  pt: {
    nav: {
      projetos: "PROJETOS",
      abordagem: "ABORDAGEM",
      sobre: "SOBRE NÓS",
      contactos: "CONTACTOS",
      admin: "Área Reservada",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
    },
    hero: {
      kicker: "PONTA DELGADA · SÃO MIGUEL · AÇORES",
      line1: "Imobiliário",
      line2: "com estratégia.",
      subtitle:
        "A AzorUnique nasce da identificação de oportunidades imobiliárias com potencial de valorização. Adquirimos terrenos, imóveis e propriedades com características diferenciadoras, analisamos o seu potencial e desenvolvemos projetos capazes de criar novo valor através da arquitetura, construção, reabilitação e posicionamento no mercado.",
      ctaPrimary: "Ver projetos",
      ctaSecondary: "Conhecer a AzorUnique",
      scroll: "Deslize para explorar",
    },
    intro: {
      eyebrow: "QUEM SOMOS",
      title: "Imobiliário com estratégia",
      p1: "A AzorUnique nasce da identificação de oportunidades imobiliárias com potencial de valorização.",
      p2: "Adquirimos terrenos, imóveis e propriedades com características diferenciadoras, analisamos o seu potencial e desenvolvemos projetos capazes de criar novo valor através da arquitetura, construção, reabilitação e posicionamento no mercado.",
      backgroundWord: "POTENCIAL",
    },
    process: {
      eyebrow: "O NOSSO MÉTODO",
      title: "Da oportunidade ao ativo de valor",
      phases: [
        { n: "01", title: "Identificar", desc: "Localizações, terrenos e imóveis com potencial." },
        { n: "02", title: "Pensar", desc: "Definir o produto adequado ao mercado, ao local e ao comprador." },
        { n: "03", title: "Transformar", desc: "Construir, reabilitar e valorizar o ativo." },
        { n: "04", title: "Valorizar", desc: "Colocar no mercado um produto com maior utilidade, qualidade e valor." },
      ],
      quote: "Não procuramos apenas imóveis. Procuramos potencial por concretizar.",
    },
    marquee: [
      "AZORUNIQUEHOME",
      "IMOBILIÁRIO COM ESTRATÉGIA",
      "FETEIRAS · AÇORES",
      "VALORIZAÇÃO PATRIMONIAL",
      "ARQUITETURA & DESENVOLVIMENTO",
    ],
    projects: {
      eyebrow: "PORTEFÓLIO",
      title: "Projetos",
      subtitle: "Uma seleção de imóveis adquiridos, desenvolvidos pela AZORUnique.",
      all: "Todos",
      loading: "A carregar projetos…",
      error: "Não foi possível carregar os projetos.",
      empty: "Sem projetos nesta categoria.",
      area: "Área",
    },
    featured: {
      eyebrow: "EM DESTAQUE · PARA VENDA",
      forSale: "Para Venda",
      cta: "Ver projeto",
      whatsapp: "Falar sobre este imóvel",
      waText: "Olá! Tenho interesse no projeto",
    },
    status: {
      "Concluídos": "Concluídos",
      "Em Desenvolvimento": "Em Desenvolvimento",
      "Reabilitação": "Reabilitação",
      "Construção Nova": "Construção Nova",
      "Vendido em Projeto": "Vendido em Projeto",
      "Em Construção": "Em Construção",
    },
    approach: {
      eyebrow: "ABORDAGEM",
      title: "Criar valor com compromisso.",
      quote:
        "Um bom projeto imobiliário começa muito antes da obra. Localização, potencial do imóvel, arquitetura, perfil do comprador, custos e valor de mercado são analisados em conjunto, para que cada decisão contribua para um projeto coerente, valorizado e ajustado ao seu objetivo.",
      principles: [
        {
          n: "01",
          title: "Localização e potencial",
          desc: "Cada projeto começa pela leitura do imóvel, da localização e do seu potencial de valorização. Procuramos oportunidades onde arquitetura, mercado e contexto possam criar valor real.",
        },
        {
          n: "02",
          title: "Produto pensado para o mercado",
          desc: "Desenvolvemos cada imóvel com um objetivo claro, considerando desde o início quem o vai utilizar, comprar ou explorar e quais as características realmente valorizadas pelo mercado.",
        },
        {
          n: "03",
          title: "Compromisso na execução",
          desc: "Planeamos cada intervenção com atenção ao orçamento, aos prazos e às decisões tomadas ao longo do projeto, procurando garantir uma execução coerente com aquilo que foi definido.",
        },
        {
          n: "04",
          title: "Proximidade e transparência",
          desc: "Mantemos uma comunicação direta e acessível com clientes e parceiros, partilhando informação de forma clara e acompanhando cada etapa com proximidade e disponibilidade.",
        },
      ],
    },
    buy: {
      eyebrow: "COMPRAR COM CONFIANÇA",
      title: "Conhecemos o imóvel porque fizemos parte da sua transformação.",
      p1: "Comprar uma casa exige mais do que uma visita e uma ficha técnica. Exige informação clara, conhecimento real do imóvel e confiança em quem está do outro lado.",
      p2: "Na AzorUnique, o contacto é direto. Conhecemos os projetos que desenvolvemos, as opções tomadas, os materiais escolhidos e a lógica por detrás de cada solução. Isso permite-nos acompanhar a compra de forma mais próxima, transparente e informada.",
      items: [
        {
          n: "01",
          title: "Contacto direto",
          desc: "Falamos diretamente com cada cliente, sem criar distância desnecessária entre quem compra e quem conhece verdadeiramente o imóvel.",
        },
        {
          n: "02",
          title: "Transparência",
          desc: "Partilhamos de forma clara as características do imóvel, as condições de aquisição e a informação relevante para cada etapa da compra.",
        },
        {
          n: "03",
          title: "Disponibilidade",
          desc: "Mantemos uma comunicação simples e acessível, para que dúvidas, decisões e informação não fiquem pendentes por falta de resposta.",
        },
        {
          n: "04",
          title: "Conhecimento do projeto",
          desc: "Conhecemos os imóveis para além do resultado final. Materiais, acabamentos, soluções construtivas, organização dos espaços e opções de projeto fazem parte de um processo em que estivemos envolvidos.",
        },
        {
          n: "05",
          title: "Acompanhamento",
          desc: "Acompanhamos o cliente desde o primeiro interesse até à escritura, ajudando a tornar o processo mais simples, coordenado e informado.",
        },
      ],
      cta: "Fale connosco",
    },
    reviews: {
      eyebrow: "TESTEMUNHOS",
      title: "A experiência dos nossos clientes",
      subtitle: "Projetos concluídos, experiências partilhadas por quem acompanhou o processo connosco.",
      formTitle: "Deixe a sua avaliação",
      name: "Nome",
      namePlaceholder: "O seu nome",
      project: "Projeto ou localização (opcional)",
      projectPlaceholder: "Ex.: Furnas, Ponta Delgada…",
      rating: "Avaliação",
      comment: "Comentário",
      commentPlaceholder: "Conte-nos como foi a sua experiência…",
      consent: "Autorizo a publicação do meu testemunho no site.",
      submit: "Enviar avaliação",
      submitting: "A enviar…",
      moderation: "A sua avaliação será revista pela nossa equipa antes de ser publicada.",
      errRating: "Selecione uma avaliação de 1 a 5 estrelas.",
      errConsent: "É necessária a autorização para publicação do testemunho.",
      errGeneric: "Não foi possível enviar a avaliação. Tente novamente.",
      thanks: "Obrigado pela sua avaliação. A sua opinião é importante para nós.",
      googleLead: "Se quiser partilhar também a sua experiência no Google, pode fazê-lo aqui.",
      googleCta: "Avaliar também no Google",
      empty: "As avaliações aprovadas serão apresentadas aqui.",
    },
    about: {
      eyebrow: "SOBRE NÓS",
      title: "Transformamos imóveis em oportunidades.",
      p1: "A AzorUnique identifica imóveis com potencial e desenvolve projetos capazes de lhes acrescentar valor.",
      p2: "Da aquisição à construção, reabilitação, definição de interiores e comercialização, cada decisão procura equilibrar arquitetura, funcionalidade, mercado e retorno do investimento.",
      p3: "Vemos em cada imóvel o potencial do que ainda pode vir a ser.",
      founderName: "Cátia Morgado",
      founderRole: "Estratégia, mercado e valorização imobiliária",
      founderBio: [
        "Licenciada em Marketing Turístico e fundadora da AzorUnique, foi uma das pioneiras no Alojamento Local na ilha de São Miguel, iniciando atividade neste setor em 2012.",
        "Com experiência no mercado imobiliário, identifica oportunidades com potencial e define a estratégia de valorização de cada projeto, acompanhando o desenvolvimento dos imóveis desde a análise inicial até à sua concretização.",
        "Cruza conhecimento de mercado, turismo e imobiliário com uma abordagem focada na funcionalidade, diferenciação e posicionamento, com um objetivo claro: transformar cada imóvel num ativo mais atrativo, competitivo e valorizado.",
      ],
      partnerEyebrow: "PARCEIRO DE ARQUITETURA",
      partnerName: "UAID Arquitetos",
      partnerText:
        "A arquitetura dos nossos projetos é desenvolvida em parceria com o atelier UAID Arquitetos.",
    },
    contact: {
      eyebrow: "CONTACTOS",
      title: "Fale connosco.",
      note: "Para propostas de investimento, apresentação de imóveis com potencial ou parcerias:",
      email: "EMAIL",
      whatsapp: "WHATSAPP",
      address: "MORADA",
      addressValue: "2.ª Chã das Cruzinhas, 8 Feteiras",
      legal: "AZORUniqueHome, Unipessoal LDA",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      admin: "Área Reservada",
      architectureBy: "Arquitetura",
    },
  },
  en: {
    nav: {
      projetos: "PROJECTS",
      abordagem: "APPROACH",
      sobre: "ABOUT US",
      contactos: "CONTACTS",
      admin: "Reserved Area",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      kicker: "PONTA DELGADA · SÃO MIGUEL · AZORES",
      line1: "Real estate",
      line2: "with strategy.",
      subtitle:
        "AzorUnique was born from identifying real estate opportunities with appreciation potential. We acquire land, properties and estates with distinctive characteristics, analyse their potential and develop projects capable of creating new value through architecture, construction, rehabilitation and market positioning.",
      ctaPrimary: "View projects",
      ctaSecondary: "Meet AzorUnique",
      scroll: "Scroll to explore",
    },
    intro: {
      eyebrow: "WHO WE ARE",
      title: "Real estate with strategy",
      p1: "AzorUnique was born from identifying real estate opportunities with appreciation potential.",
      p2: "We acquire land, properties and estates with distinctive characteristics, analyse their potential and develop projects capable of creating new value through architecture, construction, rehabilitation and market positioning.",
      backgroundWord: "POTENTIAL",
    },
    process: {
      eyebrow: "OUR METHOD",
      title: "From opportunity to valuable asset",
      phases: [
        { n: "01", title: "Identify", desc: "Locations, land and properties with potential." },
        { n: "02", title: "Think", desc: "Defining the right product for the market, the place and the buyer." },
        { n: "03", title: "Transform", desc: "Building, renovating and adding value to the asset." },
        { n: "04", title: "Add Value", desc: "Bringing to market a product with greater utility, quality and value." },
      ],
      quote: "We don't just look for properties. We look for potential waiting to be realised.",
    },
    marquee: [
      "AZORUNIQUEHOME",
      "REAL ESTATE WITH STRATEGY",
      "FETEIRAS · AZORES",
      "ASSET APPRECIATION",
      "ARCHITECTURE & DEVELOPMENT",
    ],
    projects: {
      eyebrow: "PORTFOLIO",
      title: "Projects",
      subtitle: "A selection of acquired properties, developed by AZORUnique.",
      all: "All",
      loading: "Loading projects…",
      error: "Could not load projects.",
      empty: "No projects in this category.",
      area: "Area",
    },
    featured: {
      eyebrow: "FEATURED · FOR SALE",
      forSale: "For Sale",
      cta: "View project",
      whatsapp: "Ask about this property",
      waText: "Hello! I'm interested in the project",
    },
    status: {
      "Concluídos": "Completed",
      "Em Desenvolvimento": "In Development",
      "Reabilitação": "Renovation",
      "Construção Nova": "New Build",
      "Vendido em Projeto": "Sold at Project Stage",
      "Em Construção": "Under Construction",
    },
    approach: {
      eyebrow: "APPROACH",
      title: "Creating value with commitment.",
      quote:
        "A good real estate project starts long before the works. Location, property potential, architecture, buyer profile, costs and market value are analysed together, so that every decision contributes to a coherent, valued project aligned with its goal.",
      principles: [
        {
          n: "01",
          title: "Location and potential",
          desc: "Every project starts with a reading of the property, its location and its appreciation potential. We look for opportunities where architecture, market and context can create real value.",
        },
        {
          n: "02",
          title: "Product designed for the market",
          desc: "We develop each property with a clear goal, considering from the start who will use, buy or operate it and which features are truly valued by the market.",
        },
        {
          n: "03",
          title: "Commitment in execution",
          desc: "We plan each intervention with attention to budget, deadlines and the decisions made throughout the project, seeking to ensure execution coherent with what was defined.",
        },
        {
          n: "04",
          title: "Closeness and transparency",
          desc: "We maintain direct, accessible communication with clients and partners, sharing information clearly and following each stage with closeness and availability.",
        },
      ],
    },
    buy: {
      eyebrow: "BUY WITH CONFIDENCE",
      title: "We know the property because we were part of its transformation.",
      p1: "Buying a home requires more than a visit and a spec sheet. It requires clear information, real knowledge of the property and trust in who is on the other side.",
      p2: "At AzorUnique, contact is direct. We know the projects we develop, the choices made, the materials selected and the logic behind each solution. This allows us to guide your purchase more closely, transparently and with better information.",
      items: [
        {
          n: "01",
          title: "Direct contact",
          desc: "We speak directly with each client, without creating unnecessary distance between the buyer and those who truly know the property.",
        },
        {
          n: "02",
          title: "Transparency",
          desc: "We clearly share the property's characteristics, the acquisition conditions and the information relevant to each stage of the purchase.",
        },
        {
          n: "03",
          title: "Availability",
          desc: "We keep communication simple and accessible, so questions, decisions and information are never left pending for lack of reply.",
        },
        {
          n: "04",
          title: "Project knowledge",
          desc: "We know the properties beyond the final result. Materials, finishes, construction solutions, space organisation and project choices are all part of a process we were involved in.",
        },
        {
          n: "05",
          title: "Guidance",
          desc: "We accompany the client from first interest to the final deed, helping make the process simpler, coordinated and informed.",
        },
      ],
      cta: "Talk to us",
    },
    reviews: {
      eyebrow: "TESTIMONIALS",
      title: "Our clients' experience",
      subtitle: "Completed projects, experiences shared by those who followed the process with us.",
      formTitle: "Leave your review",
      name: "Name",
      namePlaceholder: "Your name",
      project: "Project or location (optional)",
      projectPlaceholder: "E.g. Furnas, Ponta Delgada…",
      rating: "Rating",
      comment: "Comment",
      commentPlaceholder: "Tell us about your experience…",
      consent: "I authorize the publication of my testimonial on the website.",
      submit: "Submit review",
      submitting: "Submitting…",
      moderation: "Your review will be moderated by our team before publication.",
      errRating: "Please select a rating from 1 to 5 stars.",
      errConsent: "Authorization to publish the testimonial is required.",
      errGeneric: "Could not submit your review. Please try again.",
      thanks: "Thank you for your review. Your opinion matters to us.",
      googleLead: "If you'd also like to share your experience on Google, you can do so here.",
      googleCta: "Also review on Google",
      empty: "Approved reviews will be shown here.",
    },
    about: {
      eyebrow: "ABOUT US",
      title: "We transform properties into opportunities.",
      p1: "AzorUnique identifies properties with potential and develops projects capable of adding value to them.",
      p2: "From acquisition to construction, renovation, interior definition and sale, every decision seeks to balance architecture, functionality, market and investment return.",
      p3: "We see in every property the potential of what it can still become.",
      founderName: "Cátia Morgado",
      founderRole: "Strategy, market and real estate valuation",
      founderBio: [
        "With a degree in Tourism Marketing and founder of AzorUnique, she was one of the pioneers of local accommodation on the island of São Miguel, starting her activity in this sector in 2012.",
        "With experience in the real estate market, she identifies opportunities with potential and defines the appreciation strategy for each project, following the development of properties from the initial analysis through to their completion.",
        "She combines knowledge of the market, tourism and real estate with an approach focused on functionality, differentiation and positioning, with one clear goal: transforming every property into a more attractive, competitive and valuable asset.",
      ],
      partnerEyebrow: "ARCHITECTURE PARTNER",
      partnerName: "UAID Arquitetos",
      partnerText:
        "The architecture of our projects is developed in partnership with the UAID Arquitetos studio.",
    },
    contact: {
      eyebrow: "CONTACTS",
      title: "Talk to us.",
      note: "For investment proposals, submissions of properties with potential or partnerships:",
      email: "EMAIL",
      whatsapp: "WHATSAPP",
      address: "ADDRESS",
      addressValue: "2.ª Chã das Cruzinhas, 8 Feteiras",
      legal: "AZORUniqueHome, Unipessoal LDA",
    },
    footer: {
      rights: "All rights reserved.",
      admin: "Reserved Area",
      architectureBy: "Architecture",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("azor-lang") || "pt");

  useEffect(() => {
    localStorage.setItem("azor-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
